export var SuggestionEmitValueTypes;
(function (SuggestionEmitValueTypes) {
    SuggestionEmitValueTypes["CLICK"] = "click";
    SuggestionEmitValueTypes["ENTER"] = "enter";
    SuggestionEmitValueTypes["TAB"] = "tab";
    SuggestionEmitValueTypes["RESET"] = "reset";
})(SuggestionEmitValueTypes || (SuggestionEmitValueTypes = {}));
//# sourceMappingURL=autocompleteDropdown.js.map